export const groundSurfaceTileOverlapPixels = 4;
